import { render, staticRenderFns } from "./ColerLegend.vue?vue&type=template&id=75eb3e8c&scoped=true&"
import script from "./ColerLegend.vue?vue&type=script&lang=js&"
export * from "./ColerLegend.vue?vue&type=script&lang=js&"
import style0 from "./ColerLegend.vue?vue&type=style&index=0&id=75eb3e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75eb3e8c",
  null
  
)

export default component.exports